module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content_all2",
    attrs: {
      "id": "ann_page"
    }
  }, [_c('div', {
    staticClass: "content_box"
  }, [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "tx16",
    attrs: {
      "width": "50%",
      "height": "45"
    }
  }, [_vm._v(_vm._s(_vm.news.title))]), _vm._v(" "), (_vm.news.sDate) ? _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.news.sDate.split(' ')[0]))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "list_box2",
    domProps: {
      "innerHTML": _vm._s((_vm.news.context))
    }
  }, [_vm._v("\n      " + _vm._s(_vm.news) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.attachPicture))]), _vm._v(" "), _vm._l((_vm.news.pictures), function(picture, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "margin": "25px"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "212px"
      },
      attrs: {
        "src": picture.file_url
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.attachFile))]), _vm._v(" "), _vm._l((_vm.news.files), function(file, index) {
    return _c('div', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": file.file_url,
        "download": ""
      }
    }, [_vm._v(_vm._s(file.file_name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn_m fright mt15",
    attrs: {
      "type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        _vm.back($event)
      }
    }
  }, [_vm._v("回上一頁")]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-293402ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rent/AnnPage.vue
// module id = 1228
// module chunks = 3